import {
  useColorMode,
  usePreferredDark,
  type BasicColorMode,
  type UseColorModeReturn
} from '@vueuse/core'
import { computed } from 'vue'

export function useTheme() {
  const mode = useColorMode()

  const isDarkAuto = usePreferredDark()

  const isAuto = computed(() => mode.value === 'auto')
  const isDark = computed(() =>
    mode.value === 'auto' ? isDarkAuto.value : mode.value === 'dark'
  )
  const isLight = computed(() =>
    mode.value === 'auto' ? !isDarkAuto.value : mode.value === 'light'
  )

  const currentTheme = computed(() => mode.store.value)

  function setTheme(theme: UseColorModeReturn<BasicColorMode>['value']) {
    mode.value = theme
  }

  function toggleTheme() {
    switch (mode.value) {
      case 'auto':
        setTheme(isDarkAuto.value ? 'dark' : 'light')
        break
      case 'dark':
        setTheme('light')
        break
      case 'light':
        setTheme('dark')
        break
      default:
        setTheme('light')
    }
  }

  return {
    isDark,
    isDarkAuto,
    isLight,
    isAuto,
    currentTheme,
    toggleTheme,
    setTheme
  }
}
